import { Component, EventEmitter, OnInit, Output, Renderer2, ViewChild } from '@angular/core';
import { QuestionDefinition, SelectInputType } from '../../../forms/form.types';
import { IPCourse, IPCourseLIst } from '../../../shared/interface/course.interface';
import { CourseService } from '../../../shared/course.service';
import { TermService } from '../../../shared/term.service';
import { IPCourseRosterSearch, Roster, Student } from '../../../shared/interface/roster.interface';
import { GenericFormGroupComponent } from '../../../forms/generic-form-group.component';
import { AlertService } from '../../../shared/services/alert.service';
import { FormControl, Validators } from '@angular/forms';
import { Observable } from 'rxjs/Observable';
import { ScheduleTerm, ScheduleTermList } from '../../../shared/interface/term-interface';
import { GradingScheduleList } from '../../../shared/interface/grading-schedule.interface';
import { GradingScheduleService } from '../../../shared/grading-schedule.service';
import { of } from 'rxjs';
import {
    IPCourseDropDown,
    IPCourseSubmit,
    IPGradingQuestion,
    IPStudentListForUpdate
} from '../../../shared/interface/ip-grading.interface';
import { RosterService } from '../../../shared/roster.service';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { IpGradeRegistrarViewStudentComponent } from './ip-grade-view-student/ip-grade-registrar-view-student.component';
import { MatTableDataSource } from '@angular/material/table';
import { MatSort } from '@angular/material/sort';
import { MatPaginator } from '@angular/material/paginator';
import { CourseRosterIpService } from '../../../shared/course-roster-ip.service';
import { GradeValidationStatus } from '../../../shared/interface/grade-validation.interface';
import { GradePostTransactionIdService } from '../../../shared/services/grade-post-transaction-id.service';
import { IpGradeSubmitStatusComponent } from './ip-grade-submit-status/ip-grade-submit-status-component';
import {GradingRuleService} from "../../../shared/grading-rule.service";
import {GradeList} from "../../../shared/interface/grading-rule.interface";

@Component({
    selector: 'app-registrar-staff-ip-grade-registrar',
    templateUrl: './ip-grade-registrar.component.html',
    styleUrls: ['./ip-grade-registrar.component.scss']
})
export class IpGradeRegistrarComponent extends GenericFormGroupComponent implements OnInit {
    postGradeDisplayColumns: string[] = [
        'name',
        'studentId',
        'gradeBanner',
        'gradeIGrade',
        'gradeRule',
        'gradeType',
        'courseList'
    ];

    controls: {
        termCode: FormControl<string>;
        crn: FormControl<string>;
        searchTermCode: FormControl<string>;
        searchCourseCrn: FormControl<string>;
    };
    questions: {
        termCode: QuestionDefinition;
        crn: QuestionDefinition;
        searchTermCode: QuestionDefinition;
        searchCourseCrn: QuestionDefinition;
    };
    loading: boolean;

    constructor(
        public dialog: MatDialog,
        private courseService: CourseService,
        public courseRosterIPService: CourseRosterIpService,
        public rosterService: RosterService,
        private termService: TermService,
        public gradingScheduleService: GradingScheduleService,
        public gradePostTransactionIdService: GradePostTransactionIdService,
        public gradingRuleService: GradingRuleService,
        private alert: AlertService,
        protected renderer2: Renderer2
    ) {
        super(renderer2);
        this.getAllTermDropDown();
    }

    gradingSchedule: Array<GradingScheduleList>;
    allGradingTermList: Array<GradingScheduleList>;

    private allMainTermOptions: Array<ScheduleTerm> = [];
    private allTermOptions: Array<ScheduleTerm> = [];
    private optionsCourseList: Array<IPCourseDropDown> = [];

    currentTermCode: string;
    searchTermCode: string;
    searchCourseCrn: string = null;
    courseList: IPCourse[];
    resultCourse: Partial<IPCourseRosterSearch> = {};
    courseListToProcess: Array<Partial<IPCourseRosterSearch>> = [];
    showRoster: boolean = false;
    selectedCourse: IPCourse;
    isCourseLoaded: boolean = false;
    foundCourse: boolean = false;
    showConfirmation: boolean = false;
    searchCourseLoading: boolean = false;
    mainEditRosterList: Student[];
    ipStudentForUpdate: IPStudentListForUpdate[];
    postGradeResultMessage: Array<String> = [];
    mainCourseFound: boolean = false;
    mainCourseSearchDone: boolean = false;
    gradeListIP: Array<GradeList> = [];
    toShow: boolean;

    public postGradeDataSource: MatTableDataSource<IPStudentListForUpdate>;
    @ViewChild(MatSort) postGradeSort: MatSort;
    @ViewChild(MatPaginator) postGradePaginator: MatPaginator;
    @Output() postGradeDataSourceStudentList = new EventEmitter<IPStudentListForUpdate[]>();

    submitCourseData: Array<IPCourseSubmit> = [];

    validationStatus: GradeValidationStatus;

    ngOnInit(): void {
        this.initControlsAndQuestions();
        this.postGradeResultMessage.splice(0);
        this.gradingRuleService.getGradeListIP()?.subscribe((response: Array<GradeList>) => {
            this.gradeListIP = response;
        });
    }

    private initControlsAndQuestions() {
        this.controls = {
            termCode: new FormControl<string>('', Validators.required),
            crn: new FormControl<string>(null, Validators.required),
            searchTermCode: new FormControl<string>(''),
            searchCourseCrn: new FormControl<string>('')
        };
        this.createFormGroup(this.controls);

        this.questions = {
            termCode: {
                input: {
                    discriminator: 'SELECT',
                    property: 'termCode',
                    label: 'Select a Term',
                    control: this.controls.termCode,
                    optionsCallBack: {
                        this: this,
                        function: this.renderAllTermOptions
                    },
                    required: true
                }
            },
            crn: {
                input: {
                    discriminator: 'TEXT',
                    property: 'crn',
                    label: 'Type in a CRN',
                    control: this.controls.crn,
                    required: true
                }
            },
            searchTermCode: {
                input: {
                    discriminator: 'SELECT',
                    property: 'searchTermCode',
                    label: 'Select a Term',
                    control: this.controls.searchTermCode,
                    optionsCallBack: {
                        this: this,
                        function: this.renderAllTermOptions
                    }
                }
            },
            searchCourseCrn: {
                input: {
                    discriminator: 'TEXT',
                    property: 'searchCourseCrn',
                    label: 'Type in a CRN',
                    control: this.controls.searchCourseCrn
                }
            }
        };
    }

    private renderAllTermOptions(): Observable<Array<ScheduleTerm>> {
        if (this.allGradingTermList?.length) {
            this.allTermOptions = this.allGradingTermList?.map((m) => {
                return {
                    text: m.termDescription,
                    value: m.termCode
                } as ScheduleTerm;
            });
        }
        return of(this.allTermOptions);
    }

    getAllTermDropDown(): void {
        this.gradingScheduleService.getTermList().subscribe((response: Array<GradingScheduleList>) => {
            if (response) {
                this.allGradingTermList = response;
                (this.questions.searchTermCode.input as SelectInputType).updateOptions = true;
                (this.questions.termCode.input as SelectInputType).updateOptions = true;
            }
        });
    }

    cancelAdd() {
        this.questions.searchTermCode.input.control.setValue(null);
        this.questions.searchCourseCrn.input.control.setValue(null);
        this.initResultCourse();
        this.foundCourse = false;
        this.searchCourseLoading = false;
    }

    addCourse() {
        const initialCourseListSize = this.courseListToProcess?.length;
        if (
            !this.courseListToProcess?.find((item: IPCourseRosterSearch) => {
                return item.courseRoster.id == this.resultCourse.courseRoster.id;
            })
        ) {
            this.courseListToProcess.push(this.resultCourse);
            if (initialCourseListSize < this.courseListToProcess?.length) {
                //clear input
                this.cancelAdd();
            }
            this.updatePreviewList();
        }

        console.log(this.courseListToProcess);
    }

    courseStringFormat(
        termCodeDescription: String,
        subjectCode: string,
        courseNumber: string,
        sectionNumber: string,
        crn: string
    ) {
        return termCodeDescription + ' - ' + subjectCode + ' ' + courseNumber + ' ' + sectionNumber + ' (' + crn + ')';
    }

    setIPCourseText(courseRoster: IPCourseRosterSearch) {
        return this.courseStringFormat(
            courseRoster.courseRoster.course.termCodeDescription,
            courseRoster.courseRoster.course.subjectCode,
            courseRoster.courseRoster.course.courseNumber,
            courseRoster.courseRoster.course.sectionNumber,
            courseRoster.courseRoster.course.crn
        );
    }

    removeCourse(courseRoster: IPCourseRosterSearch) {
        // @ts-ignore
        this.alert.confirm({
            title: 'Are you sure you want to remove this course?',
            text: this.setIPCourseText(courseRoster),
            callBack: {
                this: this,
                function: (result: boolean) => {
                    if (result === true) {
                        //do work check result
                        const index = this.courseListToProcess.indexOf(courseRoster, 0);
                        console.log(index);

                        if (index > -1) {
                            this.courseListToProcess.splice(index, 1);
                        }
                        console.log(this.courseListToProcess);
                        this.updatePreviewList();
                    }
                }
            }
        });
    }

    onSearchMainCourseByCRN() {
        this.isCourseLoaded = false;
        const selectedFormData = this.getFormValue<IPGradingQuestion>();
        this.mainCourseFound = false;
        this.mainCourseSearchDone = false;

        //make sure is 5 character before
        if (selectedFormData?.crn?.length >= 5 && !isNaN(Number(selectedFormData?.crn)) && selectedFormData.termCode) {
            this.courseRosterIPService
                .getIPGradeCourseByTermCodeAndCrn(selectedFormData.termCode, selectedFormData.crn)
                .subscribe({
                    next: (response: IPCourseLIst) => {
                        this.mainCourseSearchDone = true;
                        this.loading = false;
                        this.toShow = true;
                        this.selectedCourse = response.list[0];
                        if(this.selectedCourse){
                            this.showRoster = true;
                            this.mainCourseFound = true;
                        }else{
                            this.mainCourseFound = false;
                            this.showRoster = false;
                        }

                    },
                    error: (err) => {
                        this.loading = false;
                        this.alert.toastErrorObject(err);
                    }
                });
        }
    }

    onSearchCourseByCRN() {
        const selectedFormData = this.getFormValue<IPGradingQuestion>();
        //make sure is 5 character before
        if (
            selectedFormData?.searchCourseCrn?.length >= 5 &&
            !isNaN(Number(selectedFormData?.searchCourseCrn)) &&
            selectedFormData.searchTermCode
        ) {
            this.getRosterData(selectedFormData.searchTermCode, selectedFormData?.searchCourseCrn);
        }
    }

    updateStudentMatchNoMatchList() {
        if (!this.resultCourse) {
            return;
        }
        const matchList = [];
        const noMatchList = [];
        const mainRoster = this.mainEditRosterList;
        const ipGradeList = this.gradeListIP;
        const localRosterService = this.rosterService;


        this.resultCourse?.courseRoster?.roster.forEach(function (student: Student) {
            if (
                mainRoster?.find((mainStudent: Student) => {
                    return (
                        mainStudent.studentId === student.studentId &&
                        localRosterService.isGradeInList(ipGradeList, student.gradeBanner)
                    );
                })
            ) {
                matchList.push(student);
            } else {
                noMatchList.push(student);
            }
        });
        this.resultCourse.studentMatchList = matchList;
        this.resultCourse.studentNotMatchList = noMatchList;
    }

    initResultCourse() {
        this.resultCourse = {};
    }

    getRosterData(termCode: string, crn: string) {
        this.searchCourseLoading = true;
        this.initResultCourse();
        this.rosterService.get(termCode, crn).subscribe((result: Roster) => {
            if (result.list.length > 0) {
                this.resultCourse.courseRoster = result.list[0];
                this.searchCourseLoading = false;
                if (this.resultCourse?.courseRoster.id) {
                    this.foundCourse = true;
                } else {
                    this.foundCourse = false;
                }
                this.updateStudentMatchNoMatchList();
                console.log('after get roster');
                console.log(this.resultCourse);
            } else {
                this.foundCourse = false;
                this.searchCourseLoading = false;
            }
        });
    }

    viewStudent(studentList: Student[]) {
        const dialogConfig = new MatDialogConfig();
        dialogConfig.data = studentList;
        dialogConfig.disableClose = true;
        const dialogRef = this.dialog.open(IpGradeRegistrarViewStudentComponent, dialogConfig);

        dialogRef.afterClosed().subscribe((result) => {});
    }

    search() {
        const selectedFormData = this.getFormValue<IPGradingQuestion>();
        if (selectedFormData?.searchTermCode && selectedFormData?.searchCourseCrn) {
            this.getRosterData(selectedFormData?.searchTermCode, selectedFormData?.searchCourseCrn);
        }
    }

    emitDataSource() {
        this.postGradeDataSourceStudentList.emit(this.postGradeDataSource?.data);
    }

    updatePreviewList() {
        // no course selected to process do not display preview

        this.ipStudentForUpdate = [];

        this.mainEditRosterList.forEach((student: Student) => {
            // only list of student that found to be updated

            const courseListStringUpdate: string[] = [];

            //to get list of course to process
            this.courseListToProcess?.forEach((o: IPCourseRosterSearch) => {
                if (
                    o.studentMatchList.find((m: Student) => {
                        return m.studentId == student.studentId;
                    })
                ) {
                    if (o) {
                        courseListStringUpdate.push(
                            this.courseStringFormat(
                                o?.courseRoster?.course?.termCodeDescription,
                                o?.courseRoster?.course?.subjectCode,
                                o?.courseRoster?.course?.courseNumber,
                                o?.courseRoster?.course?.sectionNumber,
                                o?.courseRoster?.course?.crn
                            )
                        );
                    }
                }
            });

            // update course list
            const ipStudentUpdate: IPStudentListForUpdate = {
                emailAddress: student.emailAddress,
                bannerFirstName: student.bannerFirstName,
                bannerLastName: student.bannerLastName,
                studentId: student.studentId,
                gradeBanner: student.gradeBanner,
                gradeIGrade: student.gradeIGrade,
                gradeRule: student.gradeRule,
                gradeType: student.gradeType,
                courseList: courseListStringUpdate.join(', ')
            };

            if (courseListStringUpdate?.length > 0) {
                this.ipStudentForUpdate.push(ipStudentUpdate);
            }
        });

        this.postGradeDataSource = new MatTableDataSource<IPStudentListForUpdate>(this.ipStudentForUpdate);
        this.emitDataSource();
        this.showConfirmation = true;
    }

    restValidationStatus() {
        this.validationStatus = {
            transactionId: this.gradePostTransactionIdService.getNewTransactionId(),
            totalCount: 0,
            currentCount: 0
        };
    }

    /**
     * posting IP Grade to Banner
     */
    submitIPGrade() {
        // initialized local constants

        let tempCourse: IPCourseSubmit = {
            transactionId: null,
            courseRosterId: null,
            termCode: null,
            termCodeDescription: null,
            crn: null,
            subjectCode: null,
            courseNumber: null,
            sectionNumber: null,
            studentList: []
        };

        // reset data
        this.submitCourseData.splice(0); // clear all data
        const nonSubmitCourse = tempCourse;

        // set the main course data
        nonSubmitCourse.courseRosterId = this.selectedCourse.id;
        nonSubmitCourse.termCode = this.selectedCourse.termCode;
        nonSubmitCourse.termCodeDescription = this.selectedCourse.termCodeDescription;
        nonSubmitCourse.crn = this.selectedCourse.crn;
        nonSubmitCourse.subjectCode = this.selectedCourse.subjectCode;
        nonSubmitCourse.courseNumber = this.selectedCourse.courseNumber;
        nonSubmitCourse.sectionNumber = this.selectedCourse.sectionNumber;
        nonSubmitCourse.transactionId = this.gradePostTransactionIdService.getNewTransactionId();
        this.mainEditRosterList.forEach((item: Student) => {
            nonSubmitCourse.studentList.push(item);
        });

        //first item is always main course

        /// now process the additional course we need
        this.courseListToProcess.forEach((item: Partial<IPCourseRosterSearch>) => {
            // clear temp course data
            tempCourse = {
                transactionId: null,
                courseRosterId: null,
                termCode: null,
                termCodeDescription: null,
                crn: null,
                subjectCode: null,
                courseNumber: null,
                sectionNumber: null,
                studentList: []
            };

            //setup course data
            tempCourse.courseRosterId = item.courseRoster.id;
            tempCourse.termCode = item.courseRoster.course.termCode;
            tempCourse.termCodeDescription = item.courseRoster.course.termCodeDescription;
            tempCourse.crn = item.courseRoster.course.crn;
            tempCourse.subjectCode = item.courseRoster.course.subjectCode;
            tempCourse.courseNumber = item.courseRoster.course.courseNumber;
            tempCourse.sectionNumber = item.courseRoster.course.sectionNumber;
            tempCourse.transactionId = this.gradePostTransactionIdService.getNewTransactionId();

            //search each list for student that match main course.
            item.studentMatchList.forEach((student: Student) => {
                const tempFoundStudent = nonSubmitCourse.studentList.find((studentItem: Student) => {
                    return studentItem.studentId == student.studentId;
                });

                if (tempFoundStudent) {
                    student.gradeIGrade = tempFoundStudent.gradeIGrade;
                    tempCourse.studentList.push(student);
                }
            });
            if (tempCourse.studentList.length > 0) {
                this.submitCourseData.push(tempCourse);
            }
        });

        console.log('this.submitCourseData');
        console.log(this.submitCourseData);

        // open diaglog to post data with status
        const dialogConfig = new MatDialogConfig();
        dialogConfig.data = this.submitCourseData;
        dialogConfig.disableClose = false;
        const dialogRef = this.dialog.open(IpGradeSubmitStatusComponent, dialogConfig);
        dialogRef.afterClosed().subscribe((result: Array<String>) => {
            //add change log for confirm GD, I, and Grade Change
            if (result) {
                this.reset();
                this.postGradeResultMessage = result;
                console.log(result);
            }
        });
    }

    updateMainRosterList($event) {
        this.mainEditRosterList = $event;
        const selectedFormData = this.getFormValue<IPGradingQuestion>();
        this.updatePreviewList();
        this.isCourseLoaded = true;
    }

    reset() {
        this.isCourseLoaded = false;
        this.clearAllValuesAndMarkPristine();
        console.log('here reset');
        this.questions.crn.input.control.setValue('');
        this.currentTermCode = null;
        this.courseList = [];
        this.courseListToProcess = [];
        this.mainCourseFound = false;
        this.mainCourseSearchDone = false;
        this.showRoster = false;
        this.ipStudentForUpdate = [];
    }
}
